module.exports = __webpack_public_path__ + "img/login-chullagol.6e6410a4.svg";